import { Dropdown } from 'bootstrap'

const dropdownDismissElements = document.querySelectorAll<HTMLElement>(
  '[data-bs-dismiss="dropdown"]'
)

for (const elem of dropdownDismissElements) {
  const dropdownElem = elem.closest('.dropdown')
  const dropdownToggleElem = dropdownElem?.querySelector(
    '[data-bs-toggle="dropdown"]'
  )
  if (dropdownToggleElem) {
    const dropdownInstance = Dropdown.getOrCreateInstance(dropdownToggleElem)
    if (dropdownInstance) {
      function handleAction() {
        dropdownInstance.hide()
      }
      elem.addEventListener('pointerup', handleAction)
      elem.addEventListener('keydown', (evt) => {
        if ([' ', 'Enter'].includes(evt.key)) {
          handleAction()
        }
      })
    }
  }
}
